import { RxCross1 } from "react-icons/rx";
import { IoMdFunnel } from "react-icons/io";
import { BiChevronDown } from "react-icons/bi";
import { useState, useEffect } from "react";
import axios from "axios";

export default function SortAndFilter({
  onSort = () => {},
  onFilter = () => {},
}) {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState("featured");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    categories: [],
    price: 200000, // Fixed: Changed from 500 to match your max value
  });

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get("/api/v1/category/get-category");

        if (data.success) {
          setCategories(data.category);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryChange = (categoryName) => {
    setFilters((prev) => {
      const exists = prev.categories.includes(categoryName);
      const updated = exists
        ? prev.categories.filter((c) => c !== categoryName)
        : [...prev.categories, categoryName];

      return { ...prev, categories: updated };
    });
  };

  const applyFilters = () => {
    onFilter(filters);
    setIsFilterOpen(false);
  };

  const handleSortSelect = (value) => {
    setSelectedSort(value);
    onSort(value);
    setSortOpen(false);
  };

  return (
    <div className="w-full flex justify-end items-center gap-4 py-4 border-b border-gray-100 pr-4">
      {/* SORT DROPDOWN */}
      <div className="relative">
        <button
          onClick={() => setSortOpen((o) => !o)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-200 text-black hover:bg-gray-200/50 transition rounded-full"
        >
          <span className="uppercase tracking-wide text-sm font-medium">
            Sort: {selectedSort}
          </span>
          <BiChevronDown
            className={`h-5 w-5 transition-transform ${
              sortOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {sortOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 shadow-xl rounded-lg p-2 z-50">
            {[
              { id: "featured", label: "Featured" },
              { id: "priceLowHigh", label: "Price: Low to High" },
              { id: "priceHighLow", label: "Price: High to Low" },
              { id: "newest", label: "Newest" },
            ].map((s) => (
              <button
                key={s.id}
                onClick={() => handleSortSelect(s.id)}
                className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-200/50 rounded-md"
              >
                {s.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* FILTER BUTTON */}
      <button
        onClick={() => setIsFilterOpen(true)}
        className="flex items-center gap-2 px-4 py-2 border border-gray-200 text-black hover:bg-gray-200/50 transition rounded-full"
      >
        <IoMdFunnel className="h-5 w-5" />
        <span className="uppercase tracking-wide text-sm font-medium">
          Filters
        </span>
      </button>

      {/* FILTER PANEL (RIGHT SLIDE-IN) */}
      {isFilterOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 flex justify-end">
          <div className="w-full max-w-sm h-full bg-white p-6 shadow-2xl flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold tracking-wide uppercase">
                Filters
              </h2>
              <button onClick={() => setIsFilterOpen(false)}>
                <RxCross1 className="h-6 w-6 text-black" />
              </button>
            </div>

            {/* Categories */}
            <div className="mb-8">
              <h3 className="text-sm font-semibold uppercase tracking-wide mb-4">
                Categories
              </h3>

              {loading ? (
                <p className="text-sm text-gray-500">Loading categories...</p>
              ) : categories.length === 0 ? (
                <p className="text-sm text-gray-500">No categories available</p>
              ) : (
                <div className="space-y-3 max-h-60 overflow-y-auto pr-2 custom-scroll">
                  {categories.map((cat) => (
                    <label
                      key={cat._id}
                      className="flex items-center gap-3 cursor-pointer select-none"
                    >
                      <input
                        type="checkbox"
                        checked={filters.categories.includes(cat.name)}
                        onChange={() => handleCategoryChange(cat.name)}
                        className="h-4 w-4 border-gray-200 text-black focus:ring-black"
                      />
                      <span className="text-sm">{cat.name}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>

            {/* PRICE SLIDER */}
            {/* <div className="mb-8">
              <h3 className="text-sm font-semibold uppercase tracking-wide mb-4">
                Max Price
              </h3>

              <input
                type="range"
                min="2000"
                max="200000"
                value={filters.price}
                onChange={(e) =>
                  setFilters((p) => ({ ...p, price: Number(e.target.value) }))
                }
                className="w-full accent-black"
              />
              <p className="text-sm mt-2">
                Up to ₹{filters.price.toLocaleString("en-IN")}
              </p>
            </div> */}

            {/* APPLY BUTTON */}
            <div className="mt-auto">
              <button
                onClick={applyFilters}
                className="w-full py-3 bg-black text-white uppercase tracking-wide rounded-sm hover:opacity-80 transition"
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
